/**
 * Active formatting locale (dates, numbers, currency amounts).
 *
 * Kept as module state — same pattern as `currency.ts` and `accountTimezone.ts` — so the
 * non-React formatters stay in sync with the language i18next is currently on. It is fed by
 * the `languageChanged` listener in `@/i18n`, which covers every path that switches language.
 */

import { DEFAULT_UI_LANGUAGE } from '@/lib/uiLanguage'

let activeLocale: string = DEFAULT_UI_LANGUAGE
const listeners = new Set<() => void>()

export function getActiveLocale(): string {
  return activeLocale
}

export function setActiveLocale(next: string): void {
  const normalized = typeof next === 'string' && next.trim() ? next.trim() : DEFAULT_UI_LANGUAGE
  if (normalized === activeLocale) return
  activeLocale = normalized
  listeners.forEach((listener) => listener())
}

export function subscribeActiveLocale(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
